import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Button, { ButtonProps } from '@mui/material/Button';
// Components
import SvgIcon from '../icons/SvgIcon';
// Resources
import { stringsRes } from '../../resources/strings';
import { IconCommon } from '../../resources/images';
import Loader from '../loader';
import { useBreakpoints } from '../../customHooks/useBreakpoints';

interface ExportButtonProps extends ButtonProps {
    label?: string;
    isLoading?: boolean;
    noShrink?: boolean;
}

const ExportButton: FC<ExportButtonProps> = (props: ExportButtonProps): ReactElement => {
    const { label, isLoading, noShrink, ...rest } = props;
    const { isTabletSize } = useBreakpoints();
    const classes = useStyles({ isTablet: isTabletSize, noShrink });

    return (
        <Button
            className={classes.menuButton}
            startIcon={
                isLoading ? (
                    <Loader size={11} color="secondary" />
                ) : (
                    <SvgIcon icon={IconCommon.Export} size="mediumSmall" stroke="currentColor" />
                )
            }
            title={label}
            aria-label={label}
            {...rest}
        >
            {!noShrink && isTabletSize ? '' : (label ?? stringsRes.common.export)}
        </Button>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        menuButton: (props: { isTablet: boolean; noShrink: boolean }) => ({
            fontSize: 16,
            fontWeight: 500,
            color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.secondary.light,
            '& .MuiButton-startIcon': {
                marginRight: !props.noShrink && props.isTablet ? 0 : theme.spacing(1),
            },
            '& .MuiButton-label': {
                justifyContent: 'flex-start',
            },
            '&:hover': {
                backgroundColor: 'transparent',
                cursor: 'pointer',
            },
        }),
    }),
);

export default ExportButton;
